import Vue from 'vue';
import { checkPermissionName, checkPermission } from '@/utils/handlers';
import { configHelper } from '@/views/pages/require/constants';

const isRolePartner = () =>
    checkPermissionName(['partner', 'partner_contact', 'partner_secretariat', 'partner_shipping', 'partner_secretariat_shipping']);
const isPermissionPartnerEdit = () => checkPermission('partner_request_sheet.edit');

const formatDateToJapanese = (time) => {
    if (time) {
        const date = new Date(time);
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();

        return `${year} 年 ${month} 月 ${day} 日`;
    }
    return '';
};
const formatDateTimeJapanese = (time) => {
    const daysInJapanese = ['日', '月', '火', '水', '木', '金', '土'];
    const addLeadingZero = (number) => (number < 10 ? `0${number}` : number);
    if (time) {
        const date = new Date(time);
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const hours = addLeadingZero(date.getHours());
        const minutes = addLeadingZero(date.getMinutes());
        const dayOfWeek = date.getDay();
        const dayNameInJapanese = daysInJapanese[dayOfWeek];
        return `${year} 年 ${month} 月 ${day} 日（${dayNameInJapanese}）${hours}：${minutes}`;
    }
    return '';
};

const getComponent = (tab) => {
    if (!tab.is_permanent) return 'TabContentDynamic';
    const map = {
        1: 'Tab1Require',
        2: 'Tab2Require',
        3: 'Tab3Require',
        4: 'Tab4Require',
        5: 'Tab5Require',
        6: 'Tab6Require',
        7: 'Tab7Require',
        8: 'Tab8Require',
        9: 'Tab9Require',
        10: 'Tab10Require',
        11: 'Tab11Require'
    };
    return map[tab.id] || 'div';
};

const getDynamicProps = (
    tab,
    configTabContentDynamic,
    detailBeginForDocument,
    currentUser,
    check1,
    check2,
    check3,
    check4,
    checkOrder,
    data,
    isPreview,
    processingFields
) => {
    if (!tab.is_permanent) {
        return {
            idContent: tab.make_id + '_' + configHelper.configModalPreviewPartner.indexEditor,
            informationTab: tab.information_tab,
            dynamicConfig: configTabContentDynamic(tab.information_tab),
            isDisabled: isPreview || !isPermissionPartnerEdit(),
            processingFields,
            isPreview
        };
    }

    const common = {
        detailBeginForDocument,
        currentUser,
        isDisabled: isPreview || !isPermissionPartnerEdit(),
        isPreview: isPreview || isRolePartner(),
        isNotCheckBoxPartner: isPreview,
        processingFields
    };

    switch (tab.id) {
        case 1:
            return {
                dataObject: data.information_management,
                isNotCheckBoxPartner: isPreview,
                isDisabled: isPreview || !isPermissionPartnerEdit(),
                detailBeginForDocument,
                keyTab: tab.key,
                idTab: tab.id + '_' + configHelper.configModalPreviewPartner.indexEditor,
                isPreview: isPreview || isRolePartner()
            };
        case 2:
            return {
                ...common,
                idTab: tab.id + '_' + configHelper.configModalPreviewPartner.indexEditor,
                dataObject: data.request_parameter_postcard,
                keyTab: tab.key
            };
        case 3:
            return {
                ...common,
                idTab: tab.id + '_' + configHelper.configModalPreviewPartner.indexEditor,
                dataObject: data.request_parameter_web,
                keyTab: tab.key
            };
        case 4:
            return {
                ...common,
                idTab: tab.id + '_' + configHelper.configModalPreviewPartner.indexEditor,
                dataObject: data.request_parameter_twitter_instagram,
                keyTab: tab.key
            };
        case 5:
            return {
                ...common,
                idTab: tab.id + '_' + configHelper.configModalPreviewPartner.indexEditor,
                dataObject: data.request_parameter_twitter_rt,
                keyTab: tab.key
            };
        case 6:
            return {
                ...common,
                idTab: tab.id + '_' + configHelper.configModalPreviewPartner.indexEditor,
                dataObject: data.request_parameter_line,
                keyTab: tab.key
            };
        case 7:
            return {
                ...common,
                check1,
                check2,
                check3,
                check4,
                dataObject: data.lottery_campaign_open,
                keyTab: tab.key,
                idTab: tab.id + '_' + configHelper.configModalPreviewPartner.indexEditor
            };
        case 8:
            return {
                ...common,
                check1,
                check2,
                check3,
                check4,
                dataObject: data.lottery_campaign_close,
                keyTab: tab.key,
                idTab: tab.id + '_' + configHelper.configModalPreviewPartner.indexEditor
            };
        case 9:
            return {
                ...common,
                checkOrder,
                dataObject: data.lottery_twitter,
                keyTab: tab.key,
                idTab: tab.id + '_' + configHelper.configModalPreviewPartner.indexEditor
            };
        case 10:
            return {
                ...common,
                checkOrder,
                dataObject: data.lottery_instagram,
                keyTab: tab.key,
                idTab: tab.id + '_' + configHelper.configModalPreviewPartner.indexEditor
            };
        case 11:
            return {
                ...common,
                dataObject: data.lottery_line,
                keyTab: tab.key,
                idTab: tab.id + '_' + configHelper.configModalPreviewPartner.indexEditor
            };
        default:
            return {};
    }
};

const updateDateSplit = (value, parent, key) => {
    if (value) {
        const date = value.split('-');
        parent[`${key}_y`] = date[0];
        parent[`${key}_m`] = date[1];
        parent[`${key}_d`] = date[2];
    }
};

// Hàm chính để tối ưu code
const processCampaignData = (
    detailBeginForDocument,
    large_i,
    medium_i,
    small_i,
    large_item,
    small_item,
    winning_conditions,
    reporting_schedule_postcard,
    reporting_schedule_twitter_rt,
    lottery_method,
    addressData,
    tool_form,
    data,
    checks
) => {
    const { campaign_master_order_scopes, campaign_master_order_scope_partner, categories, name } = detailBeginForDocument;

    // Helper function để tìm kiếm dữ liệu
    const findMediumItems = (item, targetLargeItem, targetMediumItem) => {
        return (
            item.large_item.value === targetLargeItem &&
            item.medium_items &&
            Array.isArray(item.medium_items) &&
            item.medium_items.find((mi) => mi.medium_item.value === targetMediumItem)
        );
    };

    // Helper function để xử lý medium_items
    const processMediumItems = (item, callback) => {
        if (item.medium_items && Array.isArray(item.medium_items)) {
            item.medium_items.forEach(callback);
        }
    };

    // Helper function để xử lý small_items
    const processSmallItems = (mi, callback) => {
        if (mi.small_items && Array.isArray(mi.small_items) && mi.small_items.length > 0) {
            mi.small_items.forEach(callback);
        }
    };

    // Helper function để xử lý detail_items
    const processDetailItems = (si, callback) => {
        if (si.detail_items && Array.isArray(si.detail_items) && si.detail_items.length > 0) {
            si.detail_items.forEach(callback);
        }
    };

    // Helper function kiểm tra tool form
    const isToolFormCondition = (it) => {
        if (!it.master_order_scope || !it.tool) return false;

        const { master_order_scope } = it;

        // Điều kiện 1: small_item với PL指定ドメイン hoặc 独自ドメイン
        const condition1 =
            master_order_scope.key === 'small_item' &&
            (master_order_scope.value === 'PL指定ドメイン' || master_order_scope.value === '独自ドメイン') &&
            master_order_scope.parent &&
            master_order_scope.parent.key === 'medium_item' &&
            master_order_scope.parent.value === 'WEBフォーム' &&
            master_order_scope.parent.parent &&
            master_order_scope.parent.parent.key === 'large_item' &&
            master_order_scope.parent.parent.value === '応募収集';

        // Điều kiện 2: medium_item với WEBフォーム
        const condition2 =
            master_order_scope.key === 'medium_item' &&
            master_order_scope.value === 'WEBフォーム' &&
            master_order_scope.parent &&
            master_order_scope.parent.key === 'large_item' &&
            master_order_scope.parent.value === '応募収集';

        return condition1 || condition2;
    };

    campaign_master_order_scopes.forEach((item) => {
        const li = item.large_item;
        large_i.push(li.value);

        // Kiểm tra và xử lý medium_items
        processMediumItems(item, (mi) => {
            medium_i.push(mi.medium_item.value);

            // Kiểm tra cho tab order
            if (mi.medium_item.value === '当選・発送データ作成') {
                checks.checkOrder = true;
            }

            // Xử lý small_items
            processSmallItems(mi, (si) => {
                if (li.value === '応募収集' && mi?.medium_item?.value === 'SNSツール') {
                    small_i.push(si.small_item.value);
                }
                large_item.push(si.small_item.value);

                // Xử lý duplicate checking
                if (mi.medium_item.value === '重複確認') {
                    switch (si.small_item.value) {
                        case '同一世帯':
                            checks.check1 = true;
                            break;
                        case '同一人物':
                            checks.check2 = true;
                            break;
                        case 'その他':
                            checks.check3 = true;
                            break;
                        case '固有ID':
                            checks.check4 = true;
                            break;
                    }
                }

                // Xử lý detail_items
                processDetailItems(si, (dt) => {
                    if (si.small_item.value === 'SNSツール') {
                        small_item.push(dt.value);
                    }

                    const winningConditions = ['引き抜き抽選', 'ランダム抽選', '条件付き抽選', 'その他'];
                    if (winningConditions.includes(dt.value)) {
                        winning_conditions.push(dt.value);
                    }
                });
            });
        });

        // Xử lý các trường hợp đặc biệt
        if (li.value === '応募収集') {
            const addressTypes = ['直住所', '私書箱', 'その他'];
            const webFormMedium = findMediumItems(item, '応募収集', 'はがき回収');
            const webFormSNS = findMediumItems(item, '応募収集', 'WEBフォーム');
            const snsMedium = findMediumItems(item, '応募収集', 'SNSツール');

            // Xử lý địa chỉ
            if (webFormMedium) {
                processSmallItems(webFormMedium, (si) => {
                    if (si.small_item && addressTypes.includes(si.small_item.value)) {
                        addressData.push(si.small_item.value);
                    }
                });
            }

            // Xử lý WEBフォーム tools
            if (webFormSNS) {
                campaign_master_order_scope_partner.forEach((it) => {
                    if (isToolFormCondition(it)) {
                        tool_form.push(it.tool.tool);
                    }
                });
            }

            // Xử lý SNS tools
            if (snsMedium) {
                const snsTypes = ['X', 'Instagram', 'LINE', 'TikTok'];

                processSmallItems(snsMedium, (si) => {
                    if (snsTypes.includes(si.small_item.value)) {
                        const overview_campaign = {
                            sns: {
                                data: si.small_item.value,
                                is_active: true,
                                first_check: { id: '', name: '', change: true },
                                secondary_check: { id: '', name: '', change: true }
                            },
                            collection_tools: {
                                data: [],
                                is_active: true,
                                first_check: { id: '', name: '', change: true },
                                secondary_check: { id: '', name: '', change: true }
                            },
                            campaign_name_atelu_only: {
                                data: '',
                                is_active: true,
                                first_check: { id: '', name: '', change: true },
                                secondary_check: { id: '', name: '', change: true }
                            },
                            tag_collected: {
                                data: '＃●●（AND／OR）＃●●',
                                is_active: true,
                                first_check: { id: '', name: '', change: true },
                                secondary_check: { id: '', name: '', change: true }
                            }
                        };

                        const collection_tools = [];
                        campaign_master_order_scope_partner.forEach((t) => {
                            if (t.master_order_scope && t.master_order_scope.id === si.small_item.id) {
                                if (t.partner.name === 'コムニコ' && t?.tool?.tool === 'ATELU') {
                                    overview_campaign.campaign_name_atelu_only.data = name;
                                }
                                if (t?.tool?.tool.toString().toLowerCase() === 'atelu') {
                                    // eslint-disable-next-line no-irregular-whitespace
                                    t.tool.tool = `ATELU \n（例）●●キャンペーン　※ATELUのキャンペーン一覧タイトルを記載`;
                                }
                                collection_tools.push(t?.tool?.tool);
                                overview_campaign.collection_tools.data = collection_tools.join('／');
                            }
                        });

                        // Xử lý hashtags từ categories
                        categories.forEach((c) => {
                            if (c.category && c.category.value === si.small_item.value) {
                                overview_campaign.tag_collected.data = c.hashtag ? c.hashtag.map((tag) => `#${tag}`).join('／') : '';
                            }
                        });
                        if (overview_campaign?.sns?.data === 'X') {
                            data.request_parameter_twitter_rt.overview_campaign = [overview_campaign];
                        }
                        if (overview_campaign?.sns?.data !== 'LINE') {
                            data.request_parameter_twitter_instagram.overview_campaign.push(overview_campaign);
                        }
                    }
                });
            }
        }

        // Xử lý 事務局関連
        if (li.value === '事務局関連') {
            const reportingScheduleTypes = ['週報', '月報', '最終一括', 'その他'];
            const lotteryTypes = ['引き抜き抽選', 'ランダム抽選', '条件付き抽選', 'その他', '引き抜き', '抽選会'];

            // Xử lý báo cáo
            const reportMedium = findMediumItems(item, '事務局関連', '通数報告');
            if (reportMedium) {
                processSmallItems(reportMedium, (si) => {
                    if (si.small_item.value === '応募数報告') {
                        processDetailItems(si, (dt) => {
                            if (reportingScheduleTypes.includes(dt.detail_item.value)) {
                                reporting_schedule_postcard.push(dt.detail_item.value);
                                reporting_schedule_twitter_rt.push(dt.detail_item.value);
                            }
                        });
                    }
                });
            }

            // Xử lý lottery
            const lotteryMedium = findMediumItems(item, '事務局関連', '抽選');
            if (lotteryMedium) {
                processSmallItems(lotteryMedium, (si) => {
                    if (si.small_item.value === 'リアル' || si.small_item.value === 'データ') {
                        processDetailItems(si, (dt) => {
                            if (lotteryTypes.includes(dt.detail_item.value)) {
                                lottery_method.push(dt.detail_item.value);
                            }
                        });
                    }
                });
            }
        }
    });
};

const initializeCheckObjects = (data) => {
    const defaultCheckObject = {
        id: '',
        name: '',
        change: true
    };

    // Helper function để khởi tạo check object
    const initializeCheck = (obj, checkType) => {
        if (!obj[checkType]) {
            obj[checkType] = { ...defaultCheckObject };
        }
    };

    // Helper function để xử lý các mảng đặc biệt
    const processSpecialArray = (data, key) => {
        if (data[key] && Array.isArray(data[key])) {
            data[key].forEach((item) => {
                initializeCheck(item, 'first_check');
                initializeCheck(item, 'secondary_check');
                item.is_active = item?.is_active ?? true;
            });
        } else if (data[key] && data[key].data && Array.isArray(data[key].data)) {
            data[key].data.forEach((item) => {
                initializeCheck(item, 'first_check');
                initializeCheck(item, 'secondary_check');
                item.is_active = item?.is_active ?? true;
            });
        }
    };

    // Helper function để xử lý overview_campaign
    const processOverviewCampaign = (data, key) => {
        if (data[key] && Array.isArray(data[key])) {
            data[key].forEach((item) => {
                for (const propertyKey in item) {
                    if (item[propertyKey]) {
                        for (const checkType in item[propertyKey]) {
                            if ((checkType === 'first_check' || checkType === 'secondary_check') && !item[propertyKey][checkType]) {
                                item[propertyKey][checkType] = { ...defaultCheckObject };
                            }
                        }
                    }
                }
            });
        }
    };

    // Duyệt qua tất cả các phần tử trong data
    for (const [key] of Object.entries(data)) {
        for (const [k] of Object.entries(data[key])) {
            if (data[key][k]) {
                // Xử lý các check object ở cấp độ đầu tiên
                for (const [l] of Object.entries(data[key][k])) {
                    if ((l === 'first_check' || l === 'secondary_check') && !data[key][k][l]) {
                        data[key][k][l] = { ...defaultCheckObject };
                    }
                }

                // Xử lý các trường hợp đặc biệt
                switch (k) {
                    case 'prizes':
                    case 'hashtags':
                    case 'twitter_rt':
                        processSpecialArray(data[key], k);
                        break;

                    case 'overview_campaign':
                        processOverviewCampaign(data[key], k);
                        break;
                }
            }
        }
    }
};

const formatPersonnelDisplay = (personInCharge, responsibleSubPersons) => {
    let result = [];
    if (personInCharge && personInCharge.name) {
        result.push(`${personInCharge.name}（メイン）`);
    }
    if (responsibleSubPersons && Array.isArray(responsibleSubPersons)) {
        responsibleSubPersons.forEach((subPerson, index) => {
            if (subPerson && subPerson.name) {
                result.push(`${subPerson.name}（サブ${index + 1}）`);
            }
        });
    }
    return result.join('　');
};

const toggleCommonSwitch = (switchValue, target) => {
    if (target) {
        if (Array.isArray(target)) {
            target.forEach((item) => {
                Vue.set(item, 'is_active', switchValue);
            });
            return target;
        }
        if (typeof target === 'object') {
            Object.keys(target).forEach((key) => {
                Vue.set(target[key], 'is_active', switchValue);
            });
            return target;
        }
    }
    return target;
};

const isVisibleFieldInTab = (target, isPreview) => {
    let isVisible = true;
    if (!isPreview) return isVisible;
    if (Array.isArray(target)) {
        isVisible = target.every((item) => item?.is_active);
    }
    if (typeof target === 'object') {
        isVisible = Object.values(target).some((item) => item?.is_active);
    }
    return isVisible;
};

const formatDataBeforeSave = (data, listSheet) => {
    const formatPrizes = (prizes = []) => {
        return prizes.map((item) => {
            return {
                first_check: item?.first_check || {},
                secondary_check: item?.secondary_check || {},
                is_active: item?.is_active || false,
                name: item.name,
                title: item.title,
                total_winner: item.total_winner,
                preliminary_winner: item.preliminary_winner,
                number_of_win_prize: item.number_of_win_prize,
                write_freely: item.write_freely || ''
            };
        });
    };

    let result = JSON.parse(JSON.stringify(data));
    result.lottery_campaign_close = {
        ...result.lottery_campaign_close,
        prizes: {
            ...result.lottery_campaign_close.prizes,
            data: formatPrizes(result.lottery_campaign_close.prizes.data)
        }
    };
    result.lottery_campaign_open = {
        ...result.lottery_campaign_open,
        prizes: {
            ...result.lottery_campaign_open.prizes,
            data: formatPrizes(result.lottery_campaign_open.prizes.data)
        }
    };
    result.partner_request_free_sheet = listSheet
        .filter((itemSheet) => !itemSheet.is_permanent)
        .map((mSheet) => {
            return {
                ...(mSheet?.id_record !== null && mSheet?.id_record !== undefined && { id: mSheet.id_record }),
                is_active: mSheet.is_active,
                sheet: mSheet.name,
                title: mSheet.information_tab.title_field,
                data: mSheet.information_tab.content_tab
            };
        });
    return result;
};

const onHandleUniqueNameTab = (listSheet, nameTab) => {
    if (!nameTab) return false;
    const isExist = listSheet.find((item) => item.name.toString().toLowerCase() === nameTab.toString().toLowerCase());
    if (isExist) return false;
    return true;
};

const formatDataShortCode = (data, listFilter = ['X', 'Instagram', 'LINE', 'TikTok'], infoApply = null) => {
    const listContentPlatform = [
        {
            plat_name: 'X',
            content: `■X
    アカウント\n(apal_open_1/aapal_open_2/bpal_open_1/bpal_open_2/cpal_open_1/cpal_open_2/pal_test_sd1)を除く`
        },
        {
            plat_name: 'Instagram',
            content: `■Instagram
    アカウント\n(ig_apal_private_1/ig_apal_private_2/ig_apal_open_1/ig_aapal_open_2/ig_bpal_private_1/ig_bpal_private_2/ig_bpal_open_1/ig_bpal_open_2/pal_sd1)を除く`
        },
        {
            plat_name: 'TikTok',
            content: `■TikTok
    アカウント(apal_open_1)を除く`
        }
    ];
    data = data.filter((i) => listFilter.includes(i.category.value));
    const formattedLines = data.map((item) => {
        const officialId = item.extension?.offical_id_sns || '';
        const officialName = item.extension?.offical_name_sns || '';
        if (!infoApply) {
            return `${item.category.value}: ${officialName}（${officialId}）`;
        } else {
            let defaultObj = {};
            switch (infoApply.tab) {
                case 'request_parameter_twitter_instagram':
                    if (!!officialId && !!officialName && infoApply.key_apply === 'test_application_1') {
                        defaultObj[infoApply.key_apply] =
                            `キャンペーン実施公式アカウント${item.category.value}: ${officialName}（${officialId}）を除く`;
                    }
                    if (infoApply.key_apply === 'test_application_2') {
                        const platContent = listContentPlatform.find((i) => i.plat_name === item.category.value);
                        defaultObj[infoApply.key_apply] = platContent ? platContent.content : '';
                    }
                    break;
                default:
                    return '';
            }
            return defaultObj[infoApply.key_apply];
        }
    });

    const result = formattedLines.filter((item) => item !== '').join('\n');

    if (listFilter.length === 1 && listFilter[0] === 'LINE') {
        return '＜応募ツールのショートコード＞\n※Lターゲット以外の場合、該当のツールの詳細情報を記載';
    }

    return result;
};

const onMapReportingScheduleLine = (campaignMasterOrderScopes) => {
    if (campaignMasterOrderScopes?.length === 0) return [];
    campaignMasterOrderScopes = campaignMasterOrderScopes?.find((item) => item.large_item.value === '事務局関連');
    if (!campaignMasterOrderScopes) return [];
    let mediumItem = campaignMasterOrderScopes?.medium_items?.find((mi) => mi.medium_item.value === '通数報告');
    if (!mediumItem) return [];
    let smallItem = mediumItem?.small_items?.find((si) => si.small_item.value === '応募数報告');
    if (!smallItem) return [];
    let detailItems = smallItem?.detail_items?.map((di) => di.detail_item.value) || [];
    return detailItems;
};

const onHandleDataCheckValueForPartner = (keyTab, dataObject, payloadData) => {
    let payload = {};
    if (typeof payloadData === 'string') {
        payload = {
            [keyTab]: {
                is_active: dataObject.is_active,
                [payloadData]: dataObject[payloadData]
            }
        };
    }
    return payload;
};

const calculateRowspan = (switches, config) => {
    let rowspan = config.base || 0;
    if (config.fields) {
        Object.entries(config.fields).forEach(([fieldName, count]) => {
            if (switches[fieldName]) {
                rowspan += count;
            }
        });
    }
    return rowspan;
};

const checkPlatFomTab = (categories, label) => {
    if (!categories) return false;
    return categories.some((item) => label.includes(item.category?.value));
};

const checkPlatFomTabLarge = (largeItem, label) => {
    if (!largeItem) return false;
    return largeItem.some((item) => label.includes(item));
};

const checkPlatFomTabSmall = (smallItem, label) => {
    if (!smallItem) return false;
    return smallItem.some((item) => label.includes(item));
};

const checkLItem = (LItem, label) => {
    if (!LItem) return false;
    return LItem.some((item) => label.includes(item));
};

const checkMItem = (MItem, label) => {
    if (!MItem) return false;
    return MItem.some((item) => label.includes(item));
};

const checkSItem = (SItem, label) => {
    if (!SItem) return false;
    return SItem.some((item) => label.includes(item));
};

const getFormUrlCustom = (categories) => {
    const foundUrlInExtension = categories?.find((cat) => cat.category?.value === 'WEB');
    return foundUrlInExtension?.extension?.form_url_custom?.filter((item) => item !== null) || null;
};

const updateAnalyticFormUrlOut = (data, categories) => {
    const formUrlCustom = getFormUrlCustom(categories);
    if (formUrlCustom && data?.information_management?.web_management_screen) {
        const currentAnalyticUrls = data.information_management.web_management_screen.analytic_form_url_out || [];
        const hasData = currentAnalyticUrls.some((item) => item && item.data && item.data.trim() !== '');
        if (hasData) {
            return;
        }
        data.information_management.web_management_screen.analytic_form_url_out = formUrlCustom.map((_, idx) => {
            return {
                data: currentAnalyticUrls[idx]?.data || ''
            };
        });
    }
};

const getPurchaseConditionDetails = (inforDocument) => {
    let { campaign_type, purchase_conditions = [] } = inforDocument;
    const hasValidCondition = campaign_type?.value === 'クローズ';
    if (!hasValidCondition) {
        return '';
    }
    if (!Array.isArray(purchase_conditions)) {
        return '';
    }
    return purchase_conditions
        ?.map((item) => item?.note?.detail)
        .filter((detail) => detail !== undefined && detail !== null && String(detail).trim() !== '')
        .join('\n');
};

export {
    isRolePartner,
    isPermissionPartnerEdit,
    formatDateToJapanese,
    formatDateTimeJapanese,
    getDynamicProps,
    getComponent,
    updateDateSplit,
    processCampaignData,
    initializeCheckObjects,
    formatPersonnelDisplay,
    toggleCommonSwitch,
    isVisibleFieldInTab,
    formatDataBeforeSave,
    onHandleUniqueNameTab,
    onMapReportingScheduleLine,
    formatDataShortCode,
    onHandleDataCheckValueForPartner,
    calculateRowspan,
    checkPlatFomTab,
    checkPlatFomTabLarge,
    checkPlatFomTabSmall,
    checkLItem,
    checkMItem,
    checkSItem,
    getFormUrlCustom,
    updateAnalyticFormUrlOut,
    getPurchaseConditionDetails
};
